import {
  defaultExplorationUrlSnapshot,
  normalizeExplorationUrlSnapshot,
} from './explorationUrlParams';
import type { DrillLocation, ExplorationFilter, ExplorationState, ViewMode } from '../types/exploration';

/**
 * Status/reason/focus overlays are view-specific vocabulary (support labels
 * vs. activation labels) — drop them on a view switch. The structural
 * facet (cluster/nodeGroup/instance/region/tag) is view-independent, so it
 * carries over unchanged.
 */
function stripViewSpecificOverlay(location: DrillLocation): DrillLocation {
  return { account: location.account, structural: location.structural };
}

function filtersForView(filters: ExplorationFilter[], view: ViewMode): ExplorationFilter[] {
  return filters.filter((f) =>
    view === 'activation' ? f.type !== 'supportStatus' : f.type !== 'activationStatus'
  );
}

export function migrateStateOnViewSwitch(
  state: ExplorationState,
  nextView: ViewMode
): Pick<ExplorationState, 'view' | 'filters' | 'drillPath' | 'overflowPages'> {
  const view = normalizeExplorationUrlSnapshot({
    ...defaultExplorationUrlSnapshot,
    view: nextView,
  }).view;

  const drillPath = stripViewSpecificOverlay(state.drillPath);

  return {
    view,
    filters: filtersForView(state.filters, view),
    drillPath,
    overflowPages: {},
  };
}
